module.exports = __webpack_public_path__ + "static/media/undraw_data-processing_ohfw.ed764fd9.svg";